import React, { memo, useCallback, useMemo, useState } from 'react';
import {
  FlexTableV2Dropdown,
  FlexTableV2DropdownItem,
  FlexTableV2DropdownMenu,
  FlexTableV2DropdownToggle
} from '../styles';
import { MdVisibility } from 'react-icons/md';

export const FlexTableV2ColumnVisibilityToggle = memo(
  ({ columns, columnVisibility, setColumnVisibility }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const columnIdToHeaderMap = useMemo(() => {
      return columns?.reduce?.((acc, col) => {
        acc[col['id']] =
          typeof col.columnDef.header === 'function'
            ? col.columnDef.header({
                header: { column: { columnDef: col.columnDef } }
              })
            : col.columnDef.header;
        return acc;
      }, {});
    }, [columns]);

    const toggleDropdown = useCallback(() => {
      setIsDropdownOpen((prev) => !prev);
    }, []);

    const handleToggleColumn = useCallback(
      (columnId) => {
        setColumnVisibility({
          ...columnVisibility,
          [columnId]: !(columnVisibility?.[columnId] ?? true)
        });
      },
      [setColumnVisibility, columnVisibility]
    );

    return (
      <FlexTableV2Dropdown isOpen={isDropdownOpen} toggle={toggleDropdown}>
        <FlexTableV2DropdownToggle>
          <MdVisibility /> Visualizar colunas
        </FlexTableV2DropdownToggle>
        <FlexTableV2DropdownMenu container="body">
          {columns
            .filter((col) => col.id !== 'select')
            .map((col) => (
              <FlexTableV2DropdownItem key={col.id} toggle={false}>
                <input
                  type="checkbox"
                  checked={columnVisibility?.[col.id] ?? true}
                  onChange={() => handleToggleColumn(col.id)}
                  id={`flex-table-v2-dropdown-item-col-${col.id}`}
                />
                <label htmlFor={`flex-table-v2-dropdown-item-col-${col.id}`}>
                  {columnIdToHeaderMap[col.id]}
                </label>
              </FlexTableV2DropdownItem>
            ))}
        </FlexTableV2DropdownMenu>
      </FlexTableV2Dropdown>
    );
  },
  (prev, next) => {
    const isSameColumnVisibility =
      JSON.stringify(prev?.columnVisibility) ===
      JSON.stringify(next?.columnVisibility);

    const isSameColumnOrder =
      prev?.columns?.map?.((col) => col.name)?.join?.() ===
      next?.columns?.map?.((col) => col.name)?.join?.();

    return isSameColumnOrder && isSameColumnVisibility;
  }
);
